import React, { useEffect, useState } from 'react';
import styles from './CookieBanner.module.scss';
import logo from '../../Assets/images/logo2.webp.webp';
import {
  getCookieConsent,
  initAnalyticsFromConsent,
  setCookieConsent,
} from '../../utils/analytics';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initAnalyticsFromConsent();
    if (!getCookieConsent()) {
      setVisible(true);
    }

    const reopen = () => setVisible(true);
    window.addEventListener('open-cookie-settings', reopen);
    return () => window.removeEventListener('open-cookie-settings', reopen);
  }, []);

  useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);

  const choose = (value) => {
    setCookieConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.card} role="dialog" aria-modal="true" aria-labelledby="cookie-title">
        <img src={logo} alt="Nounou Chou Express" className={styles.logo} />
        <h2 id="cookie-title">Bienvenue chez Nounou Chou Express</h2>
        <p>
          Avec votre accord, nous utilisons des cookies et technologies similaires,
          avec notre partenaire de mesure d'audience, pour mémoriser et analyser
          votre visite sur ce site (pages consultées, identifiants techniques).
        </p>
        <p>
          À tout moment, vous pouvez retirer votre consentement via le lien
          « Personnaliser ses cookies » en bas de page, ou dans nos mentions légales.
        </p>
        <p className={styles.purposesTitle}>Vos données peuvent être utilisées pour :</p>
        <ul>
          <li>la mesure d'audience et l'amélioration de nos services aux familles</li>
          <li>le stockage et/ou l'accès à des informations sur votre appareil</li>
        </ul>
        <p className={styles.note}>
          La réservation, le paiement et les demandes de devis fonctionnent même si vous refusez.
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.refuse} onClick={() => choose('refused')}>
            Continuer sans suivi
          </button>
          <button type="button" className={styles.accept} onClick={() => choose('accepted')}>
            Accepter et entrer
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
